import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import styles from "./favourites.module.css";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { SvgIcon } from "@cinch-labs/design-system";
export var Favourites = function() {
    var ref = useContext(SharedUiHeaderV2Context), logicStore = ref.logicStore, userStore = ref.userStore;
    var favourites = userStore.favourites;
    var ref1;
    var favouritesAmount = (ref1 = favourites === null || favourites === void 0 ? void 0 : favourites.length) !== null && ref1 !== void 0 ? ref1 : 0;
    var handleTrackEvent = logicStore.handleTrackEvent;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.link,
        children: /*#__PURE__*/ _jsxs("a", {
            href: "/my-profile/favourites",
            "aria-label": "View your favourites",
            onClick: function() {
                return handleTrackEvent({
                    name: "click",
                    category: "mega menu",
                    label: "saved favourites",
                    action: "button"
                });
            },
            "data-testid": "Favourites/Anchor",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.svg,
                    children: /*#__PURE__*/ _jsx(SvgIcon, {
                        name: "heart",
                        height: 14
                    })
                }),
                favouritesAmount > 0 && /*#__PURE__*/ _jsx("span", {
                    "data-testid": "Favourites/Amount",
                    className: cx(styles.number, styles.pulse),
                    children: favouritesAmount
                })
            ]
        })
    });
};
